<template>
  <div>
    <div class="d-flex align-items-center justify-content-center vh-100 p-4">
      <b-card-group columns>
        <b-card
          border-variant="primary"
          header="Status - por bairro"
          header-bg-variant="primary"
          header-text-variant="white"
          align="center"
        >
          <router-link to="/graficos/bairros" tag="button">
            Visualizar
          </router-link>
        </b-card>

        <b-card
          border-variant="primary"
          header="Status - por cidade"
          header-bg-variant="primary"
          header-text-variant="white"
          align="center"
        >
          <router-link to="/graficos/cidades" tag="button">
            Visualizar
          </router-link>
        </b-card>

        <b-card
          border-variant="primary"
          header="Status - por idade"
          header-bg-variant="primary"
          header-text-variant="white"
          align="center"
        >
          <router-link to="/graficos/detalhes-por-idade" tag="button">
            Visualizar
          </router-link>
        </b-card>
      </b-card-group>
    </div>
  </div>
</template>

<script>
export default {
  name: "Main"
};
</script>